import styled from "styled-components";

const ProcessedOrdersTabStyled = styled.div`

`

export default ProcessedOrdersTabStyled;